import {
  STOREFRONT_LIVE_PREVIEW_UPDATE,
  type StorefrontBootstrap,
  type StorefrontLivePreviewUpdate,
} from "@emynor/storefront-sdk";

export function isStorefrontLivePreviewUpdate(
  value: unknown,
): value is StorefrontLivePreviewUpdate {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const message = value as Record<string, unknown>;
  if (message["type"] !== STOREFRONT_LIVE_PREVIEW_UPDATE) return false;
  const payload = objectValue(message["payload"]);
  if (!payload) return false;
  const tenant = objectValue(payload["tenant"]);
  if (!tenant) return false;
  return Boolean(
    objectValue(payload["configuration"]) &&
    objectValue(payload["assetUrls"]) &&
    objectValue(payload["settingsConfiguration"]) &&
    objectValue(tenant["name"]) &&
    Array.isArray(tenant["enabledLocales"]) &&
    nullableString(tenant["logoUrl"]) &&
    nullableString(tenant["faviconUrl"]) &&
    typeof tenant["supportPhone"] === "string",
  );
}

export function applyStorefrontLivePreviewUpdate(
  bootstrap: StorefrontBootstrap,
  update: StorefrontLivePreviewUpdate,
): StorefrontBootstrap {
  if (bootstrap.mode !== "preview" || !bootstrap.storefront) return bootstrap;
  const { payload } = update;
  return {
    ...bootstrap,
    tenant: {
      ...bootstrap.tenant,
      ...payload.tenant,
      logoImage: null,
      faviconImage: null,
    },
    settings: bootstrap.settings
      ? {
          ...bootstrap.settings,
          configuration: payload.settingsConfiguration,
        }
      : null,
    storefront: {
      ...bootstrap.storefront,
      configuration: payload.configuration,
      assetUrls: payload.assetUrls,
      assetImages: {},
    },
  };
}

function objectValue(value: unknown): Record<string, unknown> | null {
  return value && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

function nullableString(value: unknown): boolean {
  return value === null || typeof value === "string";
}
